/* eslint-disable react/jsx-key */
"use client";

import React, { useEffect } from "react";
import PortfolioColorscheme from "@/app/components/PortfolioColorscheme/PortfolioColorscheme";
import PortfolioResponsiveDisplays from "@/app/components/PortfolioResponsiveDisplays/PortfolioResponsiveDisplays";
import PortfolioTypography from "@/app/components/PortfolioTypography/PortfolioTypography";
import WebsiteLogo from "@/app/components/WebsiteLogo/websitelogo";
import { WebsiteSubtitle } from "@/app/components/WebsiteSubtitle/WebsiteSubtitle";
import PortfolioTechStack from "@/app/components/PortfolioTechStack/PortfolioTechStack";
import FigmaLogo from "@/app/components/icons/figmaLogo";
import HTML5Logo from "@/app/components/icons/HTML5Logo";
import CSS3Logo from "@/app/components/icons/CSS3Logo";
import JSLogo from "@/app/components/icons/JSLogo";
import PHPLogo from "@/app/components/icons/PHPLogo";
import WordpressLogo from "@/app/components/icons/WordpressLogo";
import FirstBlockAbout from "@/components/common/FirstBlockAbout";

export default function CasaMaunt() {
  const primaryColor = "#1B2C34";
  useEffect(() => {
    // Dynamically add Inter Google font
    const interLink = document.createElement("link");
    interLink.href =
      "https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap";
    interLink.rel = "stylesheet";
    document.head.appendChild(interLink);

    // Dynamically add Cinzel font from Google Fonts
    const cinzelLink = document.createElement("link");
    cinzelLink.href =
      "https://fonts.googleapis.com/css2?family=Cinzel:wght@400;700;900&display=swap";
    cinzelLink.rel = "stylesheet";
    document.head.appendChild(cinzelLink);

    return () => {
      document.head.removeChild(interLink);
      document.head.removeChild(cinzelLink); // Cleanup on unmount
    };
  }, []);

  return (
    <>
      <section className="flex flex-col gap-[100px] my-[35px]">
        <div>
          <WebsiteLogo imageSrc="https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FCasamaunt%2Fcasamaunt%20logo.webp?alt=media&token=07dc2872-dd53-4c9b-a0d0-fcf5cd5a0d12" />
          <FirstBlockAbout
            media={{
              type: "image",
              src: "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FCasamaunt%2Fcasamaunt%20background.webp?alt=media&token=2e0a83b3-9b26-4c43-8fe8-ce432a6a9b9f",
            }}
            primaryColor={primaryColor}
          />
          <WebsiteSubtitle
            text="For the Jamaican real estate project, Casa Mount House, we delivered a complete turnkey digital solution to bring their property venture to life online. This included establishing their brand identity with a custom logotype, followed by crafting a unique website design. We then handled the full development process, building a bespoke WordPress theme and ensuring the site was populated with all necessary content. Our all-encompassing approach provided Casa Mount House with a fully realized and professional online presence to showcase their real estate offerings in Jamaica."
            title="Deliverables"
            tags={["TYPOGRAPHY", "COLORSCHEME", "RESPONSIVE DESIGN", "TECH STACK"]}
          />
        </div>

        <PortfolioTypography
          typographyData={[
            {
              headline:
                "Excellence in Cleaning Services: delivering unmatched quality and meticulous attention to detail.",
              fontFamily: "Cinzel, serif",
              fontSize: "48px",
              letterSpacing: "0%",
              lineHeight: "auto",
              textColor: "#2c2d2c",
            },
          ]}
          primaryColor={primaryColor}
        />
        <PortfolioColorscheme
          ColorschemeData={[
            {
              title: "Main color",
              color: "#1B2C34",
              rgb: "#1B2C34",
              textColor: "#FFFFFF",
            },
            {
              title: "Light Green",
              color: "#668387",
              rgb: "#668387",
              textColor: "#ffffff",
            },
            {
              title: "Gold",
              color: "#F8D39E",
              rgb: "#F8D39E",
              textColor: "#2c2d2c",
            },
            {
              title: "Black",
              color: "#2C2D2C",
              rgb: "#2C2D2C",
              textColor: "#FFFFFF",
            },
          ]}
          primaryColor={primaryColor}
        />
        <PortfolioResponsiveDisplays
          ResponsiveDisplaysData={[
            {
              type: "image",
              content:
                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FCasamaunt%2Fcasamauntpc.webp?alt=media&token=a98a0f81-5aa4-4100-8661-7d12f7f05c41",
            },
            {
              type: "image",
              content:
                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FCasamaunt%2Fcasamauntipad.webp?alt=media&token=ad63a07a-2acd-401e-87d7-9bbfc8800ad6",
            },
            {
              type: "image",
              content:
                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FCasamaunt%2Fcasamauntmobile.webp?alt=media&token=52369db5-7b0a-48bb-8eaa-6573513cda7d",
            },
          ]}
          primaryColor={primaryColor}
        />
        <PortfolioTechStack
          primaryColor={primaryColor}
          blocks={[
            {
              title: "Design",
              icons: [<FigmaLogo />],
              opacity: 5,
            },
            {
              title: "Layout Development",
              icons: [<HTML5Logo />, <CSS3Logo />, <JSLogo />],
              opacity: 15,
            },
            {
              title: "Theme Development",
              icons: [<PHPLogo />],
              opacity: 25,
            },
            {
              title: "Publishing",
              icons: [<WordpressLogo />],
              opacity: 30,
            },
          ]}
        />
      </section>
    </>
  );
}
